import Button from 'common/components/buttons/button';
import { ButtonTheme } from 'common/components/buttons/button-theme';

const getIconClasses = (theme: ButtonTheme): string => {
  switch (theme) {
    case ButtonTheme.WARNING:
      return 'bg-warning-600';
    default: // Not implemented other colours yet
      return 'bg-error-300';
  }
};

interface ModalSimpleProps {
  isOpen: boolean;
  theme: ButtonTheme;
  title: string;
  description: string;
  confirmButtonText: string;
  isLoading?: boolean;
  onConfirmModal: () => void;
  onCancelModal: () => void;
}

export const ModalSimple = ({
  isOpen,
  theme,
  title,
  description,
  confirmButtonText,
  isLoading = false,
  onConfirmModal,
  onCancelModal
}: ModalSimpleProps) => {
  return (
    <>
      <div
        className={`${isOpen ? '' : 'hidden'} relative z-50`}
        aria-labelledby="modal-simple-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-60 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="relative overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div
                    className={`mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10 ${getIconClasses(
                      theme
                    )}`}
                  >
                    <svg
                      className="h-6 w-6 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                      />
                    </svg>
                  </div>

                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3
                      className="text-lg font-medium leading-6 text-gray-900"
                      id="modal-simple-title"
                    >
                      {title}
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">{description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-end px-6 pb-6">
                <div>
                  <Button
                    theme={ButtonTheme.CANCEL}
                    identifier="cancel-modal-simple"
                    onClick={onCancelModal}
                  >
                    <span>Cancel</span>
                  </Button>
                </div>
                <div className="ml-4">
                  <Button
                    theme={theme}
                    identifier="confirm-simple-modal"
                    onClick={onConfirmModal}
                    isLoading={isLoading}
                  >
                    <span>{confirmButtonText}</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
